import RepositoryService from 'src/services/repository'

const resource = 'multiTask/session'

export default RepositoryService.utils.createCrudRepository(resource)
